import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

@Injectable()
export class AnalyticsProvider {
  firebase;

  gtag_cid = Math.floor((Math.random() * 1000000000) + 1) + '';

  constructor(
    private platform: Platform) {
      platform.ready().then(() => {
        this.firebase = (<any>window).FirebasePlugin;
      });
  }

  // Track a screen view
  // trackScreenView(pageName, eventPin?, eventName?) {
  //   if (this.platform.is("cordova")) {
  //     this.analyticsFirebase.setCurrentScreen(name)
  //       .then(() => {
  //         if (eventPin || eventName) {
  //           console.log('View successfully tracked');
  //           this.analyticsFirebase.logEvent(pageName, { eventPin: eventPin, eventName: eventName })
  //             .then(() => console.log('Event successfully tracked'))
  //             .catch(err => console.log('Error tracking event:', err));
  //         }
  //       })
  //       .catch(err => console.log('Error tracking view:', err));
  //   }
  // }
  trackScreenView(pageName, eventPin?, eventName?) {
    if (this.platform.is("cordova")) {
        this.firebase.logEvent('page_view', { page: pageName, event_pin: eventPin, event_name: eventName })
          // .then(() => console.log(`Event successfully tracked - page: ${pageName} - pin: ${eventPin} - name: ${eventName}`))
          // .catch(err => console.log('Error tracking event:', err));
    } else {
      this.gaTag('pageview', eventName + ' - ' + pageName);
    }
  }

  // Track an event with custom events and params
  buttonClickEvent(event: string) {
    if (this.platform.is("cordova")) {
      this.firebase.logEvent('button_click', { action: event })
        // .then(() => console.log(`Event successfully tracked: - ${event}`))
        // .catch(err => console.log('Error tracking event:', err));
    }  else {
      this.gaTag('button_click', event)
    }
  }

  // Track video click event
  videoClickEvent(videoLink: string, eventPin?, eventName?) {
    if (this.platform.is("cordova")) {
      this.firebase.logEvent('video_click', { videoLink: videoLink, eventPin: eventPin, eventName: eventName })
        // .then(() => console.log(`Event successfully tracked: - ${videoLink}`))
        // .catch(err => console.log('Error tracking event:', err));
    }  else {
      this.gaTag('video_link', eventName, videoLink)
    }
  }

  // Track document download event
  documentClickEvent(documentName: string, eventPin?, eventName?) {
    if (this.platform.is("cordova")) {
      this.firebase.logEvent('document_click', { documentName: documentName, eventPin: eventPin, eventName: eventName })
        // .then(() => console.log(`Event successfully tracked: - ${documentName}`))
        // .catch(err => console.log('Error tracking event:', err));
    } else {
      this.gaTag('document_download', eventName, documentName)
    }
  }

  gaTag(event, title, path?) {
    const parameters = new URLSearchParams;
    parameters.append('tid', 'UA-117929117-1'); // Google Analytics code, not GTM code
    parameters.append('t', event); // event
    parameters.append('cid', this.gtag_cid); // client id
    parameters.append('el', title); // title
    parameters.append('dl', path); // path
    fetch(`https://www.google-analytics.com/collect?v=1&${parameters.toString()}`)
      .then((response) => {
        console.log('GA', response)
    }).catch((error) => console.log(error)); // User has no internet connetion
  }

}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts